import script from "./ProductCatalogsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductCatalogsView.vue?vue&type=script&setup=true&lang=ts"

import "./ProductCatalogsView.vue?vue&type=style&index=0&id=3d2d6bfe&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d2d6bfe"]])

export default __exports__